import React from 'react';

import AddNewArticleView from 'components/SendItems/AddNewArticleView';

/**
 * @param {Object} props
 * @param {boolean} [props.onBehalfOfAuthor=false] Madde yazarın kendisi yerine onun adına mı gönderiliyor.
 *   Route kaydında verilir; `/yeni-icerik-ekle/:id` prop'suz kalıp varsayılan davranışı sürdürür.
 */
const AddNewArticle = ({ onBehalfOfAuthor = false }) => {
  return <AddNewArticleView onBehalfOfAuthor={onBehalfOfAuthor} />;
};

export default AddNewArticle;
